<template>
    <role-required role="Admin">
        <template #loading><span></span></template>
        <b>Group Admin Dashboard</b>
        <!-- TODO: remove hardcoded admin link -->
        <a
            :href="`${group.group_admin_base_url}/?token=${token}`"
            class="sc-btn sc-btn-block mt-2"
            target="_blank"
        >
            <font-awesome-icon icon="tachometer-alt" class="mr-2" />
            Admin Dashboard
            <font-awesome-icon icon="arrow-right" class="ml-2" />
        </a>
        <hr/>
    </role-required>
</template>
<script>
import { mapState } from 'vuex'
import RoleRequired from '@/components/authz/RoleRequired.vue';

export default {
    computed: mapState(["token", "group"]),
    components: { RoleRequired }
}
</script>